// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/receipt-percent.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'receipt-percent',
  version: 'outline',
  paths: [
    {
      d: 'm9 14.25 6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185ZM9.75 9h.008v.008H9.75V9Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008V13.5Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z',
    },
  ],
}
